import styled from 'styled-components'
import { BiTime as TimeIcon } from 'react-icons/bi'
import TipsResponse from './TipsResponse'
import BooksitoutImages from "../../../images/BooksitoutImages";

interface Props {
	tip: TipsResponse
	isAdmin: boolean
}

const TipsCard: React.FC<Props> = ({ tip, isAdmin = false }) => {
	return (
		<a href={`${isAdmin ? `/admin/tips/${tip.id}` : `/community/tips/${tip.id}`}`} className="mb-3 col-12 col-md-6 col-lg-4">
			<List>
				<ImageContainer>
					<Image src={tip.displayImageUrl} alt="" onError={(e) => e.target.src = BooksitoutImages.Placeholder.tips} />
				</ImageContainer>

				<div className="text-book mt-3">
					<TimeIcon className="mb-1" /> {tip.type.displayName}
				</div>

				<Title>{tip.title}</Title>
			</List>
		</a>
	)
}

const List = styled.li.attrs({
	className: 'p-3',
})`
    display: flex;
    flex-direction: column;
    padding-right: 0;
    background-color: var(--card-bg-color);
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
`

const Title = styled.h5.attrs({
	className: 'clamp-1-line',
})`
    color: var(--text-color);
`

const ImageContainer = styled.div`
	width: 100%;
	height: 0;
	padding-top: 56.25%;
	position: relative;
`

const Image = styled.img.attrs({
	className: 'img-fluid',
})`
	border-radius: 12px;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: auto;
`

export default TipsCard
